import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import Layout from '../components/layout/Layout';
import { aboutData } from '../data/mock';

const About = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-[#f9f9f6] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-[#A88B4A] font-medium text-sm tracking-widest uppercase mb-4 block">
            {aboutData.hero.subtitle}
          </span>
          <h1 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
            {aboutData.hero.title}
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {aboutData.hero.description}
          </p>
        </div>
      </section>

      {/* Main Quote & Certification */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Quote Card */}
            <div className="bg-gradient-to-br from-[#d4dcc4] to-[#c9b896] rounded-2xl p-10 text-center">
              <Heart className="w-12 h-12 mx-auto mb-6 text-[#8B9D77] stroke-1" />
              <p className="text-xl md:text-2xl italic text-gray-800 font-serif">
                "{aboutData.mainQuote.text}"
              </p>
            </div>

            {/* Certification Card */}
            <Card className="bg-[#f5f5f0] border-0 p-8 rounded-2xl">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#8B9D77] flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {aboutData.certification.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {aboutData.certification.description}
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* Meet Lacey Section */}
      <section className="py-20 bg-[#f9f9f6]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-[#A88B4A] font-medium text-sm tracking-widest uppercase mb-4 block">
              {aboutData.founder.sectionTitle}
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-800">
              {aboutData.founder.title}
            </h2>
          </div>

          <div className="space-y-6">
            {aboutData.founder.bio.map((paragraph, index) => (
              <p key={index} className="text-gray-600 leading-relaxed text-lg">
                {paragraph}
              </p>
            ))}
          </div>

          {/* Belief Statement */}
          <div className="mt-12 text-center">
            <p className="text-gray-700 mb-4">{aboutData.founder.belief}</p>
            <p className="text-xl md:text-2xl font-serif italic text-gray-800">
              {aboutData.founder.beliefStatement}
            </p>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-xl md:text-2xl italic text-gray-700 font-serif mb-4">
            "{aboutData.quote.text}"
          </p>
          <p className="text-[#A88B4A] font-medium">{aboutData.quote.reference}</p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#f9f9f6]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-gray-800 mb-6">
            {aboutData.cta.title}
          </h2>
          <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
            {aboutData.cta.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/services">
              <Button variant="outline" className="border-2 border-gray-400 text-gray-700 hover:bg-gray-100 px-8 py-6 rounded-full text-base font-medium transition-all duration-300">
                Explore Services
              </Button>
            </Link>
            <Link to="/contact">
              <Button className="bg-[#A88B4A] hover:bg-[#967A3E] text-white px-8 py-6 rounded-full text-base font-medium transition-all duration-300 hover:shadow-lg flex items-center gap-2">
                Reach Out Today
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
